export const CONTENT_TYPES = {
  VOD_ASSET: 'VOD_ASSET',
  TV_SERIES: 'TV_SERIES',
  VOD_BOOKMARK: 'VOD_BOOKMARK',
  PACKAGE: 'PACKAGE',
  EPISODE: 'EPISODE',
  VIEW_ALL: 'VIEW_ALL',
  CHANNEL: 'CHANNEL',
  BANNER: 'BANNER',
  SMALL_BANNER: 'SMALL_BANNER',
  FILTERS_BANNER: 'FILTERS_BANNER',
};
